<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import ApiService from '@/api.js'
export default {
  name: 'app',
  components: {
    
  },
  created() {
    ApiService.init();
  },  
  data() {
    return {
      
    }
  }
}
</script>

<style>
#app {
  height: 100%;
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
  color: #2c3e50;
}

a {
  text-decoration: none;
}

.el-message-box {
  width: 100% !important;
  max-width: 600px !important;
}
</style>
